import hero from './assets/images/hero.jpg';
import about from './assets/images/about.jpg';
import programs from './assets/images/programs.jpg';
import g1 from './assets/images/gallery-1.jpg';
import g2 from './assets/images/gallery-2.jpg';
import g3 from './assets/images/gallery-3.jpg';
import g4 from './assets/images/gallery-4.jpg';
import g5 from './assets/images/gallery-5.jpg';
import g6 from './assets/images/gallery-6.jpg';
import g7 from './assets/images/gallery-7.jpg';
import g8 from './assets/images/gallery-8.jpg';
import g9 from './assets/images/gallery-9.jpg';
import g10 from './assets/images/gallery-10.jpg';
import g11 from './assets/images/gallery-11.jpg';
import g12 from './assets/images/gallery-12.jpg';

import v1 from './assets/videos/video-1.mp4';
import v2 from './assets/videos/video-2.mp4';
import v3 from './assets/videos/video-3.mp4';

export const localPhotos = [
  hero, about, programs,
  g1, g2, g3, g4, g5, g6, g7, g8, g9, g10, g11, g12,
];

export const localVideos = [v1, v2, v3];
